import React from "react";
import { Col, Row } from "react-bootstrap";
import "./traupdatemodal.scss";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";
import { Link } from "react-router-dom";

const TRAUpdatedModal = (props) => {
  // TODO - Keeping it for future if update another TRA button not to be removed
  // const { isForSinglePot } = props;
  return (
    <div className="traThankyouonUpdateModal">
      <Row>
        <Col>
          <div className="close">
            <Link to="">
              <Icons
                iconname="close-large"
                variant="icon-eighteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="title mt-3">
          <div>Thanks for updating your target retirement age</div>
        </Col>
      </Row>
      <Row>
        <Row className="mt-3 content">
          <div>
            If you are self-managing your TPT pension investments, please take
            the time to make sure that your investment choice continues to meet
            your needs.
          </div>
        </Row>
      </Row>
      <Row className="container-button mt-5 mb-4 update-tra">
        <Row>
          <Col lg={6}>
            {/* TODO - Keeping it for future if update another TRA button not to
            be removed */}
            {/* {isForSinglePot && (
              <div> */}
            {/* <Buttons
                  name="Update another TRA"
                  className="tertiary"
                  handleClick={props.handleCloseButton}
                ></Buttons> */}
            {/* </div>
            )} */}
          </Col>

          <Col lg={6}>
            <div className="close-button">
              <Buttons
                className="primary"
                name="Got it!"
                disabled={false}
                handleClick={props.onCloseClick}
              />
            </div>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default TRAUpdatedModal;
